import EntityTranslationsForm from 'components/EntityTranslationsForm/EntityTranslationsForm';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import { FlexContainer } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
    isLoading: boolean;
}

const Form = (props: Props) => {
    const { baseInputProps, isLoading } = props;

    const { data, handleAttributeChange, partialTranslationKey } = baseInputProps;

    return (
        <>
            <FlexContainer>
                <CustomInput {...baseInputProps} name='description' flex={1} />
            </FlexContainer>
            <EntityTranslationsForm
                data={data}
                handleAttributeChange={handleAttributeChange ?? ((name: string, value: any) => undefined)}
                partialTranslationKey={partialTranslationKey ?? ''}
                isLoading={isLoading}
                modelName={'compulsory_kpi'}
            />
        </>
    );
};

export default Form;
